/**
 * @readonly
 * @enum {string}
 */
export const ObjectEbsSettings = Object.freeze({
    LOAD_LIMIT: 'loadLimit',
    OBJECT_ID: 'objectId'
})
